<!-- <section>
  <ion-toolbar
    *ngIf="this.enabled && this.formMaxScore != 0"
    class="score-display-head"
    (click)="toggleScoreSummary()"
  >
    <ion-label slot="start">{{
      "SHARED_TEXT.SCORING.TOTAL_SCORE" | translate
    }}</ion-label>
    <section slot="end">
      <ion-label>{{ this.formCurrentScore }}/{{ this.formMaxScore }}</ion-label>
      <ion-label
        >{{
          (this.formCurrentScore / this.formMaxScore) * 100 | number : "1.0-0"
        }}%</ion-label
      >
    </section>
  </ion-toolbar>

  <section
    *ngIf="this.showScoreSummary && this.formMaxScore != 0"
    class="summary-display"
    [ngClass]="isMobile ? 'mobile' : ''"
  >
    <ng-container *ngFor="let section of sectionInfo; let sectionIndex = index">
      <ion-toolbar
        class="score-display"
        *ngIf="!section.hidden && sectionInfo[sectionIndex].maxScore > 0"
      >
        <ion-label
          class="summary-title-segment"
          slot="start"
          [textContent]="sectionInfo[sectionIndex].title"
        />
        <section class="summary-score-segment" slot="end">
          <ion-label class="summary-score-segment-achieved">
            {{ this.enabled ? this.sectionInfo[sectionIndex].score : 0 }}/{{
              this.enabled ? this.sectionInfo[sectionIndex].maxScore : 0
            }}
          </ion-label>
          <ion-label class="summary-score-segment-achieved">
            {{
              ((this.enabled ? this.sectionInfo[sectionIndex].score : 0) /
                (this.enabled ? this.sectionInfo[sectionIndex].maxScore : 1)) *
                100 | number : "1.0-0"
            }}%
          </ion-label>
        </section>
      </ion-toolbar>
    </ng-container>
  </section>
</section> -->

<section>
  <ion-toolbar
    *ngIf="this.enabled && this.formMaxScore != 0"
    class="score-display-head"
    (click)="toggleScoreSummary()"
  >
    <ion-label slot="start">{{
      "SHARED_TEXT.SCORING.TOTAL_SCORE" | translate
    }}</ion-label>
    <section slot="end">
      <ion-label>{{ this.formCurrentScore }}/{{ this.formMaxScore }}</ion-label>
      <ion-label
        >{{
          (this.formCurrentScore / this.formMaxScore) * 100 | number : "1.0-0"
        }}%</ion-label
      >
    </section>
  </ion-toolbar>

  <div
    *ngIf="showScoreSummary && formMaxScore != 0"
    class="summary-display"
    [ngClass]="isMobile ? 'mobile' : ''"
  >
    <ng-container *ngFor="let section of sectionInfo; let sectionIndex = index">
      <div
        *ngIf="!section.hidden && section.maxScore > 0"
        class="score-display-row"
      >
        <span class="summary-title-segment">
          {{ section.title }}
        </span>
        <div class="summary-score-segment">
          <span class="summary-score-segment-achieved">
            {{ enabled ? section.score : 0 }}/{{ enabled ? section.maxScore : 0 }}
          </span>
          <span class="summary-score-segment-achieved">
            {{
              ((enabled ? section.score : 0) /
                (enabled ? section.maxScore : 1)) *
                100 | number : "1.0-0"
            }}%
          </span>
        </div>
      </div>
    </ng-container>
  </div>
</section>
